/**
 *
 * UserImage
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import iconCamN from "../../images/iconCam.svg"
import iconCam from "../../images/iconcam_blanco.svg"
import iconDel from "../../images/icon_borrar_blanco.svg"
import { loadTexts } from "../../utils/i18n"
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class UserImage extends React.Component {
  intlUserImage = loadTexts("my_profile").profileAmbassador.userImage
  state = {
    url: "",
    srcSendServer: "",
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.url != this.state.url && typeof this.props.url !== "object") {
      this.setState({ url: nextProps.url == null ? "" : nextProps.url })
    }
  }

  selectImageLogo = (event) => {
    const reader = new FileReader()

    if (!event.target.files[0]) return

    if (event.target.files[0].size <= 1024 * 1024 * 2) {
      this.setState({ srcSendServer: event.target.files[0] }, (d) => {
        this.props.setFile(this.state.srcSendServer)
      })
    } else {
      return window.message.error("El archivo sobrepaso el limite.", 5)
    }

    reader.onload = () => {
      if (reader.result.includes("image")) {
        this.setState({ url: reader.result })
      } else {
        window.message.error("El archivo no es válido.", 5)
      }
    }

    reader.readAsDataURL(event.target.files[0])
  }

  render() {
    const { isAmbassador } = this.props
    const isAvatar =
      typeof this.props.url === "string"
        ? this.props.url
          ? this.props.url.indexOf("Mask-Group")
          : false
        : true
    const isAvatarAmbassador =
      typeof this.props.url === "string"
        ? this.props.url
          ? this.props.url.indexOf("default_")
          : false
        : true
    const dataImage =
      typeof this.props.url === "string" && this.props.url != ""
        ? this.props.url
        : this.state.url

    return (
      <div className="UserImageComponent">
        <div className="UserImageComponent-textUpload">
          {dataImage == "" ? (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => this.fileInputSelectLogo.click()}>
              <img src={iconCamN} alt="user-img" />
              <br />
              {this.intlUserImage.upload}
            </div>
          ) : (
            <img className="avatar" src={dataImage} />
          )}
        </div>
        {dataImage != "" && (
          <div className="UserImageComponent-options">
            <div onClick={() => this.fileInputSelectLogo.click()}>
              <img src={iconCam} />
              <br />
              {this.intlUserImage.edit}
            </div>
            {(isAmbassador ? isAvatarAmbassador == -1 : isAvatar == -1) && (
              <div
                onClick={() =>
                  this.setState({ url: "" }, () => this.props.setFile(null))
                }>
                <img src={iconDel} />
                <br />
                {this.intlUserImage.delete}
              </div>
            )}
          </div>
        )}
        <input
          style={{ display: "none" }}
          type="file"
          accept="image/*"
          onChange={this.selectImageLogo}
          ref={(fileInputSelectLogo) =>
            (this.fileInputSelectLogo = fileInputSelectLogo)
          }
        />
      </div>
    )
  }
}

UserImage.propTypes = {}

export default UserImage
